/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface EvaluationSurveyAnswerDto
 */
export interface EvaluationSurveyAnswerDto {

    /**
     * @type {number}
     * @memberof EvaluationSurveyAnswerDto
     */
    id: number;

    /**
     * @type {string}
     * @memberof EvaluationSurveyAnswerDto
     */
    text: string;

    /**
     * @type {string}
     * @memberof EvaluationSurveyAnswerDto
     */
    value: string;

    /**
     * @type {boolean}
     * @memberof EvaluationSurveyAnswerDto
     */
    isLast: boolean;
}
